import { Button, Text, Tooltip } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { TFunction } from 'i18next';
import { ArchivedEntity } from '@texas/api/endpoints/archiveApi';
import { Locale } from '@texas/i18n/types';
import { dateFromNow } from '@texas/utils/helpers/dateHelper';
import { ArchiveTab } from './archiveTabs';

export const archiveTableColumns = (
  t: TFunction,
  tab: ArchiveTab,
  hasParent: boolean,
  canRestore: boolean,
  onRestoreOpen: (entity: ArchivedEntity) => void,
) => {
  const columnHelper = createColumnHelper<ArchivedEntity>();
  const columns = [
    columnHelper.accessor('name', {
      cell: (info) => info.getValue(),
      header: t('general.name'),
    }),
  ];

  if (tab.identifierLabelKey) {
    columns.push(
      columnHelper.accessor('identifier', {
        cell: (info) => info.getValue(),
        header: t(tab.identifierLabelKey as 'general.name'),
      }),
    );
  }

  if (hasParent) {
    columns.push(
      columnHelper.accessor('parent', {
        cell: (info) => info.getValue(),
        header: t('archivePage.belongedTo'),
      }),
    );
  }

  columns.push(
    columnHelper.accessor('archived', {
      cell: (info) => (
        <Tooltip
          label={dayjs(info.getValue())
            .locale(Locale.En)
            .format('YYYY-MM-DD HH:mm')}
        >
          <Text as="span">{dateFromNow(Locale.En, info.getValue())}</Text>
        </Tooltip>
      ),
      header: t('general.archived'),
    }),
  );

  if (canRestore) {
    columns.push(
      columnHelper.display({
        id: 'restore',
        cell: (info) => (
          <Button
            variant="entityDirectorySecondary"
            size="sm"
            onClick={() => onRestoreOpen(info.row.original)}
          >
            {t('general.restore')}
          </Button>
        ),
        header: '',
        enableSorting: false,
      }),
    );
  }

  return columns;
};
